import React from 'react';
import { css } from '@emotion/css';
import { GenericNotification } from '../../../../../common/display/genericNotification/GenericNotification';
import { Benefit } from '../../../../../../@types/benefits';
import { useGetNotifications } from '../../../../../../apiHooks/notifications.hook';
import { isDepositClosableNotification } from '../../../../../../utils/isDepositClosableNotification.util';
import { useIntl } from '@/i18n';
import { safeFormatDate } from '@/utils/dateFormat.util';

const styles = {
  notificationText: css`
    margin-top: 8px;
  `,
};

const DepositNotifications = () => {
  const { t } = useIntl();
  const { notifications } = useGetNotifications();
  if (!notifications || !notifications.DEPOSIT.messages) return null;
  const depositNotifications = notifications?.DEPOSIT.messages;

  return (
    <>
      {depositNotifications
        .map((notification) => {
          if (isDepositClosableNotification(notification, 'deposit_cancellation')) {
            return (
              <GenericNotification
                key={notification.id}
                statusType='info'
                benefit={Benefit.DEPOSIT}
                headline={t({
                  id: 'benefits.deposit.modal.overview.depositNotifications.cancelation.headline',
                  defaultMessage: 'Mietkautionsbürgschaft bei der Allianz gekündigt',
                })}
                content={
                  <p className={styles.notificationText}>
                    {t(
                      {
                        id: 'benefits.deposit.modal.overview.depositNotifications.cancelation.messsage',
                        defaultMessage: 'Deine Mietkautionsbürgschaft bei der Allianz wurde zum {dateAt} beendet.',
                      },
                      {
                        dateAt: safeFormatDate(notification.params.cancelledAt, ''),
                      },
                    )}
                  </p>
                }
                id={notification.id}
              />
            );
          }

          if (isDepositClosableNotification(notification, 'deposit_reduction')) {
            return (
              <GenericNotification
                statusType={'info'}
                benefit={Benefit.DEPOSIT}
                headline={t({
                  id: 'benefits.deposit.modal.overview.depositNotifications.reduction.headline',
                  defaultMessage: 'Kautionssumme wurde reduziert',
                })}
                content={
                  <p className={styles.notificationText}>
                    {t({
                      id: 'benefits.deposit.modal.overview.depositNotifications.reduction.messsage',
                      defaultMessage: 'Die Kautionssumme wurde bei der Allianz reduziert',
                    })}
                  </p>
                }
                id={notification.id}
              />
            );
          }

          return null;
        })
        .filter((element): element is JSX.Element => Boolean(element))}
    </>
  );
};

export default DepositNotifications;
